/*
 * cf-mobile-floaters.js - Click Fencing, 2026-09-13.
 *
 * WHY. Pete: "fix the mobile checkout first". Shopify, 30 days to 13 Sep: 2,270 phone visits to the
 * home page gave 4 add-to-carts; the same page on desktop gave 13 carts and 12 checkouts. A phone
 * walk-through (375x812) found the floating buttons sitting on top of the buttons that sell:
 *
 *   - Gate/spa build pages: the quick-price chat bubble (#qpw-bubble, z-index 999999) covered the
 *     right-hand third of "Add N items to cart" in the sticky bar (.cfgb-bar, z-index 40), and the
 *     "Send us your plans" pill (.cf-plans) covered the price. elementFromPoint on the button's right
 *     edge returned #qpw-bubble.
 *   - Calculators: the Next/Add bar (#cf-cmc-bar) already lifts .cf-plans (cf-calc-mobile-cta.js),
 *     but nothing lifted the bubble, so it hid behind the bar edge.
 *   - Cart: the only Check out button sits below every line item and the totals, 1,400px down on a
 *     one-build cart. There was no way to check out without scrolling past everything.
 *
 * WHAT THIS DOES (phones only, <= 749px, matching cf-mobile-extra.liquid):
 *   1. Measures whichever bottom action bar is actually on screen and lifts the bubble and the pill
 *      above it, so nothing overlaps a buy button. Recomputed on scroll/resize/DOM change.
 *   2. On /cart, adds a sticky "Subtotal | Check out" bar that appears while the real Check out
 *      button is off screen. Its button submits the theme's own cart form, so Shopify's checkout is
 *      unchanged. The subtotal comes from /cart.js, not the DOM.
 * Nothing here runs on desktop.
 */
(function () {
  'use strict';
  var MQ = window.matchMedia('(max-width: 749px)');
  var GAP = 12;

  function css(text) {
    var s = document.createElement('style');
    s.setAttribute('data-cf', 'mobile-floaters');
    s.textContent = text;
    document.head.appendChild(s);
  }

  css([
    '@media screen and (max-width:749px){',
    '  #qpw-bubble{width:52px!important;height:52px!important;right:14px!important;',
    '    bottom:calc(var(--cf-float-lift,0px) + 16px)!important;transition:bottom .18s ease,opacity .18s ease!important}',
    '  #qpw-bubble svg{width:24px!important;height:24px!important}',
    '  .cf-plans{bottom:calc(var(--cf-float-lift,0px) + 16px)!important;transition:bottom .18s ease,opacity .18s ease!important}',
    '  #cf-cart-bar{position:fixed;left:0;right:0;bottom:0;z-index:2147482001;display:flex;align-items:center;gap:12px;',
    '    padding:10px 16px calc(10px + env(safe-area-inset-bottom,0px));background:#fff;border-top:1px solid rgba(0,0,0,.1);',
    '    box-shadow:0 -6px 20px rgba(0,0,0,.08);transform:translateY(110%);transition:transform .18s ease;font-family:inherit}',
    '  #cf-cart-bar.cf-in{transform:translateY(0)}',
    '  #cf-cart-bar .cf-cb-t{flex:1;min-width:0;line-height:1.2}',
    '  #cf-cart-bar .cf-cb-l{display:block;font-size:12px;letter-spacing:.05em;text-transform:uppercase;color:#6b6f75}',
    '  #cf-cart-bar .cf-cb-a{display:block;font-size:19px;font-weight:700;color:#1c2228;font-variant-numeric:tabular-nums;white-space:nowrap}',
    '  #cf-cart-bar button{flex:0 0 auto;min-height:48px;padding:0 26px;border:0;border-radius:8px;background:#1c2228;color:#fff;',
    '    font:inherit;font-weight:700;font-size:16px;cursor:pointer}',
    '}'
  ].join('\n'));

  // Use the bar's own height, not "innerHeight - rect.top": with the browser toolbar showing, a
  // bottom-fixed bar can report a rect.top below innerHeight while it is plainly on screen (measured:
  // top 819 on an 812 viewport), which made the lift read 0 and left the bubble under the bar.
  function visibleBar() {
    /* 2026-10-08: + #cf-cs-bar, the sticky "Continue to checkout" bar on /pages/quote-review - the
       question button sat on 87% of it (phone deep dive). */
    var sel = ['#cf-cart-bar.cf-in', '#cf-cmc-bar.cf-cmc-in', '.cfgb-bar', '#cf-cs-bar'];
    var best = 0;
    for (var i = 0; i < sel.length; i++) {
      var els = document.querySelectorAll(sel[i]);
      for (var j = 0; j < els.length; j++) {
        var el = els[j];
        var cs = getComputedStyle(el);
        if (cs.display === 'none' || cs.visibility === 'hidden' || cs.position !== 'fixed') continue;
        best = Math.max(best, el.offsetHeight);
      }
    }
    return best;
  }

  var raf = 0;
  function update() {
    raf = 0;
    var lift = MQ.matches ? visibleBar() : 0;
    document.documentElement.style.setProperty('--cf-float-lift', (lift ? Math.round(lift + GAP - 16) : 0) + 'px');
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(update); }

  // ---- cart sticky checkout ----
  function money(cents) {
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  // The cart DRAWER also carries a checkout button (hidden, but with a real on-screen rect), so
  // "is the checkout button on screen" must ignore it or the bar never appears. Found in the phone test.
  function realCheckout() {
    var list = document.querySelectorAll('#checkout, button[name="checkout"], input[name="checkout"]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.closest('cart-drawer, #CartDrawer, .cart-drawer, .drawer')) continue;
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || el.getClientRects().length === 0) continue;
      return el;
    }
    return null;
  }
  function cartBar() {
    if (!/^\/cart\/?$/.test(location.pathname)) return;
    var real = realCheckout();
    if (!real || document.getElementById('cf-cart-bar')) return;
    var bar = document.createElement('div');
    bar.id = 'cf-cart-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Cart total and checkout');
    bar.innerHTML = '<div class="cf-cb-t"><span class="cf-cb-l">Subtotal</span><span class="cf-cb-a">&nbsp;</span></div>' +
      '<button type="button">Check out</button>';
    document.body.appendChild(bar);
    var amt = bar.querySelector('.cf-cb-a');
    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          amt.textContent = money(c.total_price);
          if (!c.item_count) bar.style.display = 'none';
        })
        .catch(function () {});
    }
    refresh();
    document.addEventListener('cart:updated', refresh);
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('cart-items')) setTimeout(refresh, 900); });
    bar.querySelector('button').addEventListener('click', function () {
      var current = realCheckout();
      if (current) current.click();
    });
    // IntersectionObserver, not a window scroll listener: in the phone test the bar stayed up after
    // scrolling the real Check out button into view, because the scroll never reached the listener.
    var onScreen = false;
    function apply() {
      bar.classList.toggle('cf-in', MQ.matches && !onScreen);
      schedule();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[entries.length - 1].isIntersecting;
        apply();
      }, { threshold: 0.6 }).observe(real);
    } else {
      document.addEventListener('scroll', function () {
        var r = real.getBoundingClientRect();
        onScreen = r.top < window.innerHeight && r.bottom > 0;
        apply();
      }, { passive: true, capture: true });
    }
    if (MQ.addEventListener) MQ.addEventListener('change', apply);
    apply();
  }

  function init() {
    cartBar();
    update();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (MQ.addEventListener) MQ.addEventListener('change', schedule);
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    setInterval(schedule, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
